module.exports = __webpack_public_path__ + "img/Neutro_Corpo_1.dbf401c5.png";